module.exports = __webpack_public_path__ + "static/media/left_frog_lat.1ec25037.jpg";